export default __webpack_public_path__ + "static/media/defaultImage.35146211.svg";